import React from 'react';
import { Button } from '../ui/button';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
        this.setState({ error, errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-12 sm:px-6 lg:px-8">
                    <div className="max-w-md w-full space-y-8 text-center">
                        <div>
                            <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
                                Something went wrong.
                            </h2>
                            <p className="mt-2 text-sm text-muted-foreground">
                                We're sorry, but an unexpected error occurred. Please try refreshing the page.
                            </p>
                        </div>
                        <div className="mt-5">
                            <Button onClick={() => window.location.reload()} className="w-full">
                                Refresh Page
                            </Button>
                        </div>
                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <div className="mt-8 text-left bg-red-50 p-4 rounded overflow-auto max-h-64">
                                <p className="text-red-800 font-mono text-xs">
                                    {this.state.error.toString()}
                                </p>
                                <pre className="text-red-600 font-mono text-xs mt-2">
                                    {this.state.errorInfo.componentStack}
                                </pre>
                            </div>
                        )}
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
